import { FieldModel, PracticeContentDataTypes, ResourceDetail } from '@cibo/core'
import { ListCell } from '@cibo/ui'
import { GridCellParams } from '@mui/x-data-grid-pro'
import { usePracticesInformation } from '../../queries'

export const ResourceConcernAddressedCell = ({
  row: { details },
}: GridCellParams<any, FieldModel>) => {
  const { data, isLoading } = usePracticesInformation()

  if (data === undefined) {
    return
  }

  const currentPracticesDetail = details.find(
    (detail: ResourceDetail) => detail.traitId === 'eqipSelectedPractices'
  )
  const currentSelectedPracticesID = currentPracticesDetail?.result || []

  const currentPractices = data.items.filter((practice: PracticeContentDataTypes) =>
    currentSelectedPracticesID.includes(practice.fields.practiceId)
  )

  const resourceConcernsAddresedList: string[] = []

  currentPractices.forEach((practice: PracticeContentDataTypes) => {
    const currentPracticeResourceConcern = practice.fields.resourceConcernsAddresed.split(',')
    currentPracticeResourceConcern.forEach(rc => {
      if (!resourceConcernsAddresedList.includes(rc)) {
        resourceConcernsAddresedList.push(rc)
      }
    })
  })

  return (
    <ListCell<string>
      isLoading={isLoading}
      listItems={resourceConcernsAddresedList}
      accessor={(practice: string) => practice}
    />
  )
}
